import { motion, AnimatePresence } from "framer-motion";
import { useLanguage, translations } from "@/context/LanguageContext";

export default function LanguageModal() {
  const { showModal, setLanguage } = useLanguage();

  if (!showModal) return null;

  const languages = [
    { code: "es", name: "Español", flag: "🇲🇽" },
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "fr", name: "Français", flag: "🇫🇷" },
  ];

  return (
    <AnimatePresence>
      {showModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", duration: 0.5 }}
            className="bg-white rounded-2xl p-5 sm:p-6 max-w-xs w-full shadow-2xl"
          >
            <div className="text-center mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_mex-catnip-promo/artifacts/eeist4qj_LOGO%20FONDO%20TRANSPARENTE.png" 
                alt="GatoFeliz Logo" 
                className="h-16 w-auto mx-auto mb-4"
              />
              <h2 className="font-gluten text-2xl sm:text-3xl text-agave mb-2">
                {translations.es.lang_title}
              </h2>
              <p className="font-nunito text-sm text-muted-foreground">
                Select your language / Choisissez votre langue
              </p>
            </div>

            <div className="flex flex-col items-center gap-4">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => setLanguage(lang.code)}
                  className="w-48 flex items-center justify-center gap-3 px-4 py-3 rounded-xl border-2 border-transparent hover:border-agave bg-bone hover:bg-agave/10 transition-all duration-200 group"
                  data-testid={`lang-${lang.code}`}
                >
                  <span className="text-2xl">{lang.flag}</span>
                  <span className="font-fredoka text-base text-foreground group-hover:text-agave transition-colors">
                    {lang.name}
                  </span>
                </button>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
